<template>
    <div class="right-8">

        <div class="relative">
            <button @mouseenter="showSibling = true" @mouseleave="handleMouseLeave"
                    class="pinned-menu hover-trigger mb-3 flex h-10 w-10 items-center justify-center rounded bg-white p-1">
                <PtIcon icon="SolidMenu4" class="rounded text-2xl group-hover:bg-gray-hover" />
            </button>

            <div v-show="showSibling" @mouseenter="isHoveringSibling = true" @mouseleave="handleContentMouseLeave"
                 class="pinned-menu absolute right-12 top-0 max-h-[600px] w-60 flex-col overflow-y-auto rounded-xl bg-white">
                <slot></slot>
            </div>
        </div>

    </div>
</template>

<script setup lang="ts">
import { PtIcon } from 'patsnap-biz';
import { ref } from 'vue';
import '@patsnap-ui/icon/assets/solid/Menu4.svg';

const showSibling = ref(false);
const isHoveringSibling = ref(false);

function handleMouseLeave() {
    const it = setTimeout(() => {
        if (!isHoveringSibling.value) {
            showSibling.value = false;
        }
    }, 100);
    return () => clearTimeout(it);
}

function handleContentMouseLeave() {
    isHoveringSibling.value = false;
    handleMouseLeave();
}
</script>

<style lang="scss">
.pinned-menu {
    box-shadow: 0 2px 20px 0 rgba(0, 84, 183, 0.07);
}
</style>
